import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ClientModulesComponent } from './client-modules.component';
import { AddClientModuleComponent } from './add-client-module/add-client-module.component';
import { EditClientModuleComponent } from './edit-client-module/edit-client-module.component';

@NgModule({
  declarations: [ClientModulesComponent, AddClientModuleComponent, EditClientModuleComponent],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
  exports: [ClientModulesComponent],
})
export class ClientModulesModule { }
